import OwnerAndEmployeeCensusV3 from "./OwnerAndEmployeeCensusV3/OwnerAndEmployeeCensus";
import OwnerAndEmployeeCensusV1 from "./OwnerAndEmployeeCensusV1/OwnerAndEmployeeCensus";
import { useGetOwnerAndEmployeeCensusQuery } from "types/generated/operations";
import { getProspectUuid } from "utils/idHelpers";
import Loader from "uicomponents/Loader";
import Error from "uicomponents/Error";
import { hasQueryParam } from "utils/helper";

interface IOwnersProps {
  setNextStep: () => void;
  setPreviousStep: () => void;
}

const OwnerAndEmployeeCensusModel = ({ ...props }: IOwnersProps) => {
  const { data, error, loading, refetch } = useGetOwnerAndEmployeeCensusQuery({
    variables: { uuid: getProspectUuid() },
    fetchPolicy: "no-cache",
  });

  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <Error />;
  }

  const v2_dedupe_census_flow = hasQueryParam("usecensustab");
  const wc_flow_with_core_app = hasQueryParam("usecoreapp");

  return v2_dedupe_census_flow || wc_flow_with_core_app ? (
    <OwnerAndEmployeeCensusV3
      setNextStep={props.setNextStep}
      setPreviousStep={props.setPreviousStep}
      data={data?.prospect}
      refetchData={refetch}
    />
  ) : (
    <OwnerAndEmployeeCensusV1
      setNextStep={props.setNextStep}
      setPreviousStep={props.setPreviousStep}
      data={data?.prospect}
    />
  );
};

export default OwnerAndEmployeeCensusModel;
